import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { ToggleButton } from "primereact/togglebutton";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Datetime from "react-datetime";
import moment from "moment";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import APIConstant from "utils/constant";
import api from "utils/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { CommonConfig } from "CommonConfig";
import cogoToast from "cogo-toast";
import _, { debounce } from "lodash";
import { TieredMenu } from "primereact/tieredmenu";
import { MultiSelect } from "primereact/multiselect";
// import ReactToPrint from "react-to-print";
import {
  AutoSizer,
  List,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";
import NumericKeypadDropdown from "components/NumericKeyboard/NumericDropdown";

const POSItemCard = React.memo(function POSItemCard({
  item,
  icon,
  iconColor,
  type,
  isSelected,
  isNotItemTab,
  itemStockList,
  selectedWarehouse,
  userPageAccess,
  onPin,
  UnPin,
  selectItemDialogData,
  setSelectItemDialog,
  setSelectItemDialogData,
  setSelectedCardItem,
  setSelectedCardItemType,
  handleAddToList,
  getAvailableQuantity,
  selectedRateMap,
  onRowChange,
}) {
  let rate = item.Variant?.Price;
  if (item.Variant?.Batches?.length) {
    rate = item.Variant.Batches[0]?.Rate || item.Variant.Batches[0]?.Mrp;
  }
  if (item.SelectedRate) {
    rate = item.SelectedRate;
  }

  if (
    (type === "pinned" || type === "recent") &&
    selectedRateMap?.has?.(item.value)
  ) {
    rate = selectedRateMap.get(item.value);
  }

  const [qty, setQty] = React.useState(type === "recent" ? item.Qty : 1);
  const [size, setSize] = React.useState(rate);
  const qtyInputRef = React.useRef();
  const [showKeyboard, setShowKeyboard] = React.useState(false);
  const qtyInputWrapperRef = React.useRef();

  React.useEffect(() => {
    if (isSelected && qtyInputRef.current?.inputRef?.current) {
      const inputEl = qtyInputRef.current.inputRef.current; // PrimeReact InputNumber exposes .input
      inputEl.focus();
      inputEl.select();
    }
  }, [isSelected]);

  let isDifferentAndMultipleBatches = false;

  let batchQtymap = {};
  let itemStock = itemStockList?.find((stock) => stock.ItemId === item.value);
  if (itemStock && itemStock.BatchQuantityDetails?.length) {
    itemStock.BatchQuantityDetails.forEach((batch) => {
      let tempBatch = item.Variant.Batches.find(
        (itemBatch) => itemBatch._id === batch.BatchId,
      );

      if (selectedWarehouse.includes(batch.SubWarehouseId)) {
        if (!batchQtymap[batch.BatchId]) {
          batchQtymap[batch.BatchId] = {
            BatchNo: batch.BatchNo,
            BatchId: batch.BatchId,
            Quantity: batch.Quantity,
            Rate: tempBatch?.Rate || tempBatch?.Mrp,
            Mrp: tempBatch?.Mrp,
          };
        } else {
          batchQtymap[batch.BatchId].Quantity += batch.Quantity;
        }
      }
    });
  }
  let qtyLength = 0;
  let rateChange = false;
  Object.values(batchQtymap).forEach((batch) => {
    if (rate != batch.Rate) {
      rateChange = true;
    }
    if (batch.Quantity >= 1) {
      qtyLength += 1;
    }
  });
  if (qtyLength > 1 && rateChange) {
    isDifferentAndMultipleBatches = true;
  }

  let tempUrl = "";
  if (item.Variant.Photos?.length) {
    const filename = item.Variant.Photos[0].filename;
    tempUrl = `${process.env.REACT_APP_API_ENDPOINT}/document/${filename}`;
  }

  let bgClass = "item-card";
  if (isSelected) bgClass += " selected";
  else if (type === "pinned") bgClass += " pinned";
  else if (item.IsPinned) bgClass += " flagged";

  return (
    <div className={bgClass}>
      {!isNotItemTab && (
        <div className="pin-icon">
          {type === "pinned" || (type === "normal" && item.IsPinned) ? (
            <Tooltip title="Unpin this item">
              <span onClick={() => UnPin(item)}>📌</span>
            </Tooltip>
          ) : type === "recent" ? (
            <i className={`pi ${icon}`} style={{ color: iconColor }} />
          ) : (
            <Tooltip title="Pin this item">
              <span onClick={() => onPin(item)}>📍</span>
            </Tooltip>
          )}
        </div>
      )}

      <div
        className="card-body"
        onClick={() => {
          let temp = true;
          if (item.value === selectItemDialogData?.value) {
            temp = false;
          }
          if (isDifferentAndMultipleBatches && temp) {
            setSelectItemDialog(true);
            setSelectItemDialogData({
              ...item,
              BatchQty: batchQtymap,
              list: Object.values(batchQtymap).map((batchDetails) => ({
                label: `${batchDetails.BatchNo} - ${batchDetails.Rate} (qty-${batchDetails.Quantity}) `,
                value: batchDetails.BatchId,
                rate: batchDetails.Rate,
              })),
            });
          } else {
            setSelectedCardItem(item);
            setSelectedCardItemType(type);
            setQty(1);
            setSize(rate);

            if (typeof onRowChange === "function") {
              setTimeout(() => onRowChange(), 0);
            }
          }
        }}
      >
        <div className="text-block">
          <div className="item-name">{item.Variant.Name}</div>
          <div className="item-sub">
            {item.Variant.WeightVolume + " " + item.Variant.UnitName} •{" "}
            {item.BrandName} • ₹{rate}{" "}
            {userPageAccess?.includes?.("Show Available Quantity") &&
              "(" + getAvailableQuantity(item) + ")"}
          </div>
        </div>
        <img
          src={tempUrl}
          alt={item.name}
          className="item-image"
          loading="lazy"
        />
      </div>

      {isSelected && (
        <div className="qty-action" ref={qtyInputWrapperRef}>
          <div className="qty-input-group">
            <Button
              icon="pi pi-minus"
              className="qty-btn"
              onClick={() => {
                let tempQty = Math.max(qty - 1, 0.1);
                setQty(tempQty);
                if (rate && tempQty) {
                  setSize(tempQty * rate);
                } else {
                  setSize("");
                }
              }}
            />
            <InputNumber
              value={qty}
              ref={qtyInputRef}
              onChange={(e) => {
                setQty(e.value);
                if (rate && e.value) {
                  setSize(e.value * rate);
                } else {
                  setSize("");
                }
              }}
              onFocus={() => setShowKeyboard(true)}
              min={0}
              inputStyle={{ width: "60px", textAlign: "center" }}
              className="qty-input"
              maxFractionDigits={3}
            />
            {showKeyboard && (
              <NumericKeypadDropdown
                anchorRef={qtyInputWrapperRef}
                onSelect={(val) => {
                  setQty(val);
                  setSize(val * rate);
                }}
                onClose={() => setShowKeyboard(false)}
              />
            )}

            <Button
              icon="pi pi-plus"
              className="qty-btn"
              onClick={() => {
                let tempQty = qty + 1;
                setQty(tempQty);
                if (rate && tempQty) {
                  setSize(tempQty * rate);
                } else {
                  setSize("");
                }
              }}
            />
            <InputNumber
              value={size}
              onChange={(e) => {
                if (rate) {
                  let tempQty = e.value / parseFloat(rate);
                  if (tempQty >= 0.1) {
                    setQty(tempQty);
                    setSize(e.value);
                  } else if (!e.value) {
                    setQty(1);
                  }
                }
              }}
              min={0}
              inputStyle={{ width: "60px", textAlign: "center" }}
              className="qty-input"
              maxFractionDigits={2}
            />
          </div>
          <Button
            icon="pi pi-arrow-right"
            className="add-btn"
            onClick={() => handleAddToList(item, qty, rate)}
          />
        </div>
      )}
    </div>
  );
});

const initialCustomerDetails = {
  CustomerName: "",
  CustomerNameErr: false,
  CustomerNameErrText: "",
  GST: "",
  ContactNo: "",
  ContactNoErr: "",
  ContactNoErrText: "",
  EmailId: "",
  Address: "",
  State: "",
  CompanyName: "",
};

const AddPOS = (props) => {
  const initialFormData = {
    Date: new Date(),
    DateErr: false,
    DateErrText: "",
    Customer: "",
    CustomerErr: false,
    CustomerErrText: "",
    ContactNo: "",
  };
  const [isStaffAccess, setIsStaffAccess] = useState(false);
  const [allowNegativeStock, setAllowNegativeStock] = useState(false);
  const [printBill, setPrintBill] = useState(false);
  const [lock, setLock] = useState(false);
  const [search, setSearch] = useState("");
  const [dialogSearch, setDialogSearch] = useState("");
  const [userId, setUserId] = useState("");
  const [posId, setPosId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [staffDetails, setStaffDetails] = useState({
    staff: "",
    staffErr: false,
    staffErrText: "",
    pin: "",
    pinErr: "",
    pinErrText: "",
  });
  const [addCustomerDialog, setAddCustomerDialog] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [addPastDataListDialog, setAddPastDataListDialog] = useState(false);
  const [billNo, setBillNo] = useState("");
  const [pastDataList, setPastDataList] = useState([]);
  const [addRecentListDialog, setAddRecentListDialog] = useState(false);
  const [recentDataList, setRecentDataList] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(
    initialCustomerDetails,
  );
  const [productList, setProductList] = useState([]);

  const [selectedTab, setSelectedTab] = useState("Item");
  const [pinnedItems, setPinnedItems] = useState([]);
  const [recentItems, setRecentItems] = useState([]);
  const [sortedItems, setSortedItems] = useState([]);
  const [filterSortedItems, setFilterSortedItems] = useState([]);
  const [groupedList, setGroupedList] = useState([]); // for Brand/SubCategory
  const listCacheRef = useRef(
    new CellMeasurerCache({ defaultHeight: 220, fixedWidth: true }),
  );
  const listRef = useRef(null);
  const [selectedCardItem, setSelectedCardItem] = useState(null);
  const [selectedCardItemTyper, setSelectedCardItemType] = useState("");
  const [qty, setQty] = useState(1);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [open, setOpen] = useState(true);
  const [brandList, setBrandList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState(true);
  const [addServiceChargeDialog, setAddServiceChargeDialog] = useState(false);
  const [serviceCharge, setServiceCharge] = useState({
    service: "",
    serviceErr: false,
    serviceErrText: "",
    amount: "",
    amountErr: false,
    amountErrText: "",
  });
  const [nonGstServiceCharges, setNonGstServiceCharges] = useState([]);
  const [listType, setListType] = useState(true);
  const [latestDetails, setLatestDetails] = useState({});
  const [warehouseList, setWarehouseList] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [serviceChargesList, setServiceChargesList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [itemStockList, setItemStockList] = useState([]);
  const [selectItemDialog, setSelectItemDialog] = useState(false);
  const [selectItemDialogData, setSelectItemDialogData] = useState({});
  const [selectedBatchItem, setSelectedBatchItem] = useState(null);
  const [printData, setPrintData] = useState({});
  // const printButtonRef = useRef(null);
  const componentRef = useRef(null);
  const [barcodeConfig, setBarcodeConfig] = useState([]);
  const [clickData, setClickData] = useState({});
  const [openleft, setOpenleft] = useState({});
  const [content, setContent] = useState({
    header: "",
    footer: "",
    image: "",
  });

  const [quantityPopupDetails, setQuantityPopupDetails] = useState({
    Quantity: "",
    QuantityErr: false,
    QuantityErrText: "",
    open: false,
  });

  const [billDetails, setBillDetails] = useState({
    billType: 0,
    inclusion: 0,
    payment: 1,
    salesType: 1,
    businessType: 1,
    paymentMode: { id: "", label: "" },
  });

  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage,
  );
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions,
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);

  const [formData, setFormData] = useState(initialFormData);
  const [barcodeVariantsDialog, setBarcodeVariantsDialog] = useState(false);
  const [barcodeVariants, setBarcodeVariants] = useState([]);
  const [selectedBarcodeVariants, setSelectedBarcodeVariants] = useState([]);
  const [barcodeParentItem, setBarcodeParentItem] = useState(null);

  const [templateHtml, setTemplateHtml] = useState("");
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const wrapperRefs = useRef({});
  const [discountConfig, setDiscountConfig] = useState("");
  const [previewDialog, setPreviewDialog] = useState(false);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.PosId) {
      GetPOSById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      } else {
        GetCustomerList(data);
        GetConfigurationByConfigurationName(data);
        GetNegativeStockAccess(data);
        GetInventoryBill(data);
        GetStaffList(data);
        GetVariantList(data);
        GetWarehouseMaster(data);
        GetAccountConfiguration(data);
        GetAccountConfigurationData(data);
        GetPOSConfigurationByConfigurationName(data);
        GetBarcodeConfigurationByConfigName(data);
        GetAuditOrderList(data);
        GetServiceChargesList(data);
        GetPaymentModeList(data);
        GetImageConfiguration(data);
      }
    } else {
      GetStaffList(data);
      GetConfigurationByConfigurationName(data);
      GetNegativeStockAccess(data);
      GetInventoryBill(data);
      GetCustomerList(data);
      GetVariantList(data);
      GetWarehouseMaster(data);
      GetAccountConfiguration(data);
      GetAccountConfigurationData(data);
      GetBarcodeConfigurationByConfigName(data);
      GetPOSConfigurationByConfigurationName(data);
      GetAuditOrderList(data);
      GetServiceChargesList(data);
      GetPaymentModeList(data);
      GetImageConfiguration(data);
    }
  }, []);

  useEffect(() => {
    if (!isInitialLoad) {
      debouncedSearch(search, sortedItems);
    }
    setIsInitialLoad(false);
  }, [search]);

  const debouncedSearch = useCallback(
    debounce((keyword, sortedItems) => {
      setItemsOnSearch(keyword, sortedItems);
    }, 1000),
    [],
  );

  useEffect(() => {
    if (!isInitialLoad) {
      debouncedDialogSearch(listType, dialogSearch, userId);
    }
  }, [dialogSearch]);

  const debouncedDialogSearch = useCallback(
    debounce((listType, keyword, userId) => {
      GetLatestInvoiceList(listType, {}, keyword, userId);
    }, 400),
    [],
  );

  const setItemsOnSearch = (keyword, sortedItems) => {
    if (!keyword) {
      // If search is empty, show the full original list
      setFilterSortedItems(sortedItems);
      return;
    }

    const lowerSearch = keyword.toLowerCase();

    const filtered = sortedItems
      .map((section) => {
        const matchedItems = section.Items.filter((item) =>
          item?.Variant?.Name?.toLowerCase().includes(lowerSearch),
        );

        return {
          ...section,
          Items: matchedItems,
        };
      })
      .filter((section) => section.Items.length > 0); // Remove letters with no matching items

    setFilterSortedItems(filtered);
  };

  const GetPOSById = async (UserId) => {
    let params = {
      UserId: UserId,
      POSId: props.location.state.PosId,
    };
    api.post(APIConstant.path.GetPOSById, params).then(async (res) => {
      let response = await res;
      if (response.Success === 1) {
        if (response.Data) {
          setPosId(props.location.state.PosId);
          setProductList(response.Data.ProductList);
          setBillNo(response.Data.BillNo);
          setNonGstServiceCharges(response.Data.ServiceCharges || []);
          setFormData({
            Date: response.Data.POSDate
              ? new Date(response.Data.POSDate)
              : new Date(),
            DateErr: false,
            DateErrText: "",
            Customer: response.Data.Customer,
            CustomerErr: false,
            CustomerErrText: "",
            ContactNo: response.Data.ContactNo,
          });
          setBillDetails({
            billType: !response.Data.IsGst,
            inclusion: !response.Data.IsInclusive,
            salesType: response.Data.SalesType === "INTERSTATE",
            businessType: response.Data.BusinessType === "B2B",
            payment: response.Data.Payment === "Upfront Payment",
            paymentMode: response.Data.paymentMode || { id: "", label: "" },
          });
        }
      }
    });
  };

  const GetConfigurationByConfigurationName = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "Staff Access",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setLock(!!response.Data.ConfigurationValue);
            setIsStaffAccess(!!response.Data.ConfigurationValue);
          }
        }
      });
  };

  const GetNegativeStockAccess = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "Allow Negative Stock",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setAllowNegativeStock(!!response.Data.ConfigurationValue);
          }
        }
      });
  };

  const GetInventoryBill = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "Invetory Bill",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setPrintBill(!!response.Data.ConfigurationValue);
          }
        }
      });
  };

  const GetStaffList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Staff",
    };
    api
      .post(APIConstant.path.GetStaffList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setStaffList(filterArry);
        }
      })
      .catch(() => {});
  };

  const GetCustomerList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Customer",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setCustomerList(filterArry);
        }
      })
      .catch(() => {});
  };

  const GetVariantList = async (UserId) => {
    let params = { UserId };
    api
      .post(APIConstant.path.GetVariantListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          const filterArry = response.Data;

          // Initialize groups A-Z
          const groupedItems = Array.from({ length: 26 }, (_, i) => ({
            letter: String.fromCharCode(65 + i), // A to Z
            Items: [],
          }));

          // Populate each group
          filterArry.forEach((item) => {
            const firstChar = item.label?.[0]?.toUpperCase();
            const group = groupedItems.find((g) => g.letter === firstChar);
            if (group) {
              group.Items.push(item);
            }
          });

          GetPinnedItems(UserId, filterArry);
          GetRecentItemList(UserId, filterArry);
          GetBrandMaster(UserId, filterArry);
          GetSubCategoryMaster(UserId, filterArry);

          setSortedItems(groupedItems);
          setFilterSortedItems(groupedItems);
        }
      })
      .catch(() => {});
  };

  const GetVariantByBarcode = async (UserId) => {
    let params = { UserId, Barcode: formData.Barcode };
    api
      .post(APIConstant.path.GetVariantByBarcode, params)
      .then((response) => {
        if (response.Success === 1) {
          setFormData((prevSatate) => ({
            ...prevSatate,
            Barcode: "",
          }));
          const apiData = response.Data;

          if (
            apiData.IsProductBarcode &&
            apiData.Variants &&
            Array.isArray(apiData.Variants)
          ) {
            // Root match - show variants dialog
            const flattenedVariants = [];
            apiData.Variants.forEach((variant) => {
              flattenedVariants.push({
                ...variant,
                _id: variant._id,
                VariantId: variant._id,
                DisplayName: `${variant.Name} (Rate: ${variant.Price})`,
                OriginalName: variant.Name,
                Batch: null,
                qty: 1,
              });
            });
            setBarcodeParentItem(apiData);
            setBarcodeVariants(flattenedVariants);
            setSelectedBarcodeVariants([]);
            setBarcodeVariantsDialog(true);
          } else {
            // Specific variant/batch match
            if (apiData.Variant.PackagingType === "Fixed") {
              handleAddToList(apiData, 1, "", "barcode");
            } else {
              setQuantityPopupDetails({
                open: true,
                Quantity: "",
                QuantityErr: false,
                QuantityErrText: "",
              });
              setSelectedCardItem(apiData);
              setSelectedCardItemType("normal");
            }
          }
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch(() => {});
  };

  const GetBrandMaster = async (UserId, ItemList) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;

          let tempData = filterArry
            .map((brand) => ({
              label: brand.label,
              items: ItemList.filter((item) => item.Brand === brand.value).map(
                (item) => ({
                  ...item,
                  label: item.Variant.Name,
                  command: () => handleItemClick(item),
                }),
              ),
            }))
            .filter((brand) => brand.items.length);
          setBrandList(tempData);
        }
      })
      .catch((err) => {});
  };

  const GetSubCategoryMaster = async (UserId, ItemList) => {
    try {
      let params = {
        UserID: UserId,
      };
      await api
        .post(APIConstant.path.GetSubCategoryMaster, params)
        .then((response) => {
          if (response.Success === 1) {
            let filterArry = response.Data;

            let tempData = filterArry
              .map((subCategory) => ({
                label: subCategory.label,
                items: ItemList.filter(
                  (item) => item.SubCategory === subCategory.value,
                ).map((item) => ({
                  ...item,
                  label: item.Variant.Name,
                  command: () => handleItemClick(item),
                })),
              }))
              .filter((subCategory) => subCategory.items.length);
            setSubCategoryList(tempData);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            }),
          );
          setWarehouseList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetAuditOrderList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetAuditOrderList, params)
      .then((response) => {
        if (response.Success === 1) {
          setItemStockList(
            response.Data.map((res) => ({
              ...res,
              Quantity:
                res.QuantityDetails.reduce(
                  (accumulator, current) => accumulator + current.Quantity,
                  0,
                ) || 0,
              Godown: res.QuantityDetails.length,
            })),
          );
        }
      })
      .catch((err) => {});
  };
  const GetServiceChargesList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetServiceCharges, params)
      .then((response) => {
        if (response.Success === 1) {
          setServiceChargesList(response.Data);
        }
      })
      .catch((err) => {});
  };
  const GetPaymentModeList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetPaymentModeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          setPaymentModeList(response.Data);
        }
      })
      .catch((err) => {});
  };

  const GetPOSConfigurationByConfigurationName = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "POS Discount",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setDiscountConfig(response.Data.ConfigurationValue);
          }
        }
      });
  };

  const AddUpdateNetwork = async () => {
    setLoading(true);
    if (validateCustomer()) {
      try {
        let params = {
          UserId: userId,
          UserType: "Customer",
          CustomerDetails: {
            CustomerName: customerDetails.CustomerName,
            ContactNo: customerDetails.ContactNo,
            EmailId: customerDetails.EmailId,
            Address: customerDetails.Address,
            State: customerDetails.State,
            CompanyName: customerDetails.CompanyName,
            GST: customerDetails.GST,
            IsGstVerified: false,
          },
        };
        api
          .post(APIConstant.path.AddUpdateNetwork, params)
          .then((response) => {
            setLoading(false);
            if (response.Success === 1) {
              cogoToast.success(response.Message);
              handleClose("Customer");
              GetCustomerList(userId);
            } else {
              cogoToast.error(response.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const AddUpdatePOS = async (isDraft) => {
    setLoading(true);
    if (validate()) {
      try {
        const discount =
          userPageAccess.includes("POS Discount") && discountConfig
            ? parseFloat(discountConfig)
            : 0;

        const processedProductList = productList.map((product) => {
          const rate = parseFloat(product.Rate || 0);
          const quantity = parseFloat(product.Quantity || 0);
          let discountedRate = rate;
          let subTotal = parseFloat(product.SubTotal || 0);

          if (discount > 0 && !product.isServiceCharge) {
            discountedRate = rate - (rate * discount) / 100;
            subTotal = discountedRate * quantity;
          }

          return {
            ...product,
            Rate: rate,
            DiscountedRate: discountedRate,
            SubTotal: product.SubTotal,
            DiscountedSubTotal: subTotal,
          };
        });

        let params = {
          UserId: userId,
          POSId: posId,
          BillNo: billNo,
          IsGst: !billDetails.billType,
          IsInclusive: !billDetails.inclusion,
          Payment: billDetails.payment ? "Upfront Payment" : "Credit",
          SalesType: billDetails.salesType ? "INTERSTATE" : "INTRA-STATE",
          BusinessType: billDetails.businessType ? "B2B" : "B2C",
          PaymentMode: billDetails.paymentMode,
          POSDate: formData.Date,
          POSStatus: isDraft ? "Draft" : "Completed",
          Customer: formData.Customer,
          CustomerName: customerList.find(
            (customer) => customer.value === formData.Customer,
          )?.label,
          ServiceCharges: nonGstServiceCharges.map((ngsc) => ({
            ServiceName: ngsc.ServiceName,
            Amount: ngsc.Amount,
            ServiceChargesId: ngsc.ServiceChargesId,
          })),
          ContactNo: formData.ContactNo,
          Discount: discount > 0 ? discount : null,
          ProductList: processedProductList,
          WarehouseDetails: selectedWarehouse.map((warehouse) => ({
            id: warehouse,
            name: warehouseList.find((wh) => wh.value === warehouse)?.label,
          })),
          IsStaffAccess: isStaffAccess,
          StaffDetails: isStaffAccess
            ? {
                StaffId: staffDetails.staff,
                StaffName: staffList.find(
                  (staff) => staff.value === staffDetails.staff,
                )?.label,
              }
            : null,
        };
        api
          .post(APIConstant.path.AddUpdatePOS, params)
          .then((response) => {
            setLoading(false);
            if (response.Success === 1) {
              cogoToast.success(response.Message);
              if (!!printBill && !isDraft) {
                handlePrint(
                  formData,
                  productList,
                  response.Data,
                  nonGstServiceCharges,
                );
              }
              setBillNo("");
              setPosId("");
              setProductList([]);
              setNonGstServiceCharges([]);
              setFormData(initialFormData);
              if (props.location.state) {
                props.history.replace({
                  ...props.location,
                  state: {},
                });
              }
            } else {
              cogoToast.error(response.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };
  const AddUpdateAccountConfiguration = async (warehouses) => {
    try {
      let params = {
        UserId: userId,
        Type: "Warehouse",
        Data: warehouses.map((warehouse) => ({
          id: warehouse,
          name: warehouseList.find((wh) => wh.value === warehouse)?.label,
        })),
      };
      api
        .post(APIConstant.path.AddUpdateAccountConfiguration, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const GetAccountConfiguration = async (UserId) => {
    try {
      let params = {
        UserId,
        Type: "Warehouse",
      };
      api
        .post(APIConstant.path.GetAccountConfiguration, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            if (response?.Data?.Data) {
              setSelectedWarehouse(response.Data.Data.map((wh) => wh.id));
            }
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const AddUpdateAccountConfigurationData = async (tempDetails) => {
    try {
      let params = {
        UserId: userId,
        Type: "Bill Details",
        Data: tempDetails,
      };
      api
        .post(APIConstant.path.AddUpdateAccountConfiguration, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const GetAccountConfigurationData = async (UserId) => {
    try {
      let params = {
        UserId,
        Type: "Bill Details",
      };
      api
        .post(APIConstant.path.GetAccountConfiguration, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            if (response?.Data?.Data) {
              setBillDetails(response.Data.Data);
            }
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const GetBarcodeConfigurationByConfigName = async (UserId) => {
    try {
      setLoading(true);
      let data = {
        UserId,
        ConfigName: "Billing Configuration",
      };
      await api
        .post(APIConstant.path.GetBarcodeConfigurationByConfigurationName, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            setBarcodeConfig(response.Data);
          }
        })
        .catch((err) => {
          console.log({ err });
        });
    } catch (err) {
      console.log({ err });
    }
  };

  const GetImageConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetImageConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp?.success) {
            const image = `${process.env.REACT_APP_NODE_API_ENDPOINT}/document/${resp?.data[0]?.ImagePath}`;
            setContent({
              header: resp?.data[0]?.Header,
              footer: resp?.data[0]?.Description,
              image: image,
            });
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const AddPinnedItem = async (pinnedData) => {
    try {
      let params = {
        UserId: userId,
        Items: pinnedData.map((item) => ({
          ItemId: item.value,
          ItemName: item.Variant.Name,
          Brand: item.Brand,
          Unit: item.Variant.Unit,
        })),
      };
      api
        .post(APIConstant.path.AddPinnedItems, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetPinnedItems = async (UserId, ItemList) => {
    try {
      let params = {
        UserId,
      };
      api
        .post(APIConstant.path.GetPinnedItems, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            if (response.Data.length) {
              let tempList = [];
              response.Data.forEach((pinItem) => {
                let tempItem = ItemList.find(
                  (item) => item.value === pinItem.ItemId,
                );
                if (tempItem) {
                  tempItem.IsPinned = true;
                  tempList.push(tempItem);
                }
              });
              setPinnedItems(tempList);
            }
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const GetRecentItemList = async (UserId, ItemList) => {
    try {
      let params = {
        UserId,
      };
      api
        .post(APIConstant.path.GetRecentItemList, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            if (response.Data.length) {
              let tempList = [];
              let tempItemList = _.cloneDeep(ItemList);
              response.Data.forEach((recentItem) => {
                let tempItem = tempItemList.find(
                  (item) => item.value === recentItem.ProductId,
                );
                tempItem.Qty = recentItem.Quantity;
                if (tempItem) {
                  tempItem.IsPinned = false;
                  tempList.push(tempItem);
                }
              });
              setRecentItems(tempList);
            }
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const GetLatestInvoiceData = async (e, isPrint) => {
    try {
      let params = {
        UserId: userId,
      };
      api
        .post(APIConstant.path.GetLatestInvoiceData, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            if (response.Data.ProductList.length) {
              // let tempProductList = [
              //   ...productList,
              //   ...response.Data.ProductList,
              // ];
              // const mergedProducts = {};
              // (tempProductList || []).forEach((item) => {
              //   const key = `${item.ProductId}-${item.UnitId}-${item.BrandId}-${item.SubCategory}-${item.Rate}-${item.Mrp}`;

              //   if (!mergedProducts[key]) {
              //     mergedProducts[key] = { ...item };
              //   } else {
              //     mergedProducts[key].Quantity += Number(item.Quantity || 0);
              //     mergedProducts[key].SubTotal += Number(item.SubTotal || 0);
              //   }
              // });
              // setProductList(Object.values(mergedProducts));
              if (!isPrint) {
                setAddRecentListDialog(true);
                setLatestDetails({
                  Customer: response.Data.Customer,
                  CustomerName: response.Data.CustomerName,
                  ContactNo: response.Data.ContactNo,
                });
                setRecentDataList(response.Data.ProductList);
              } else {
                handleInvoicePrint(response.Data);
              }
            }
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const GetLatestInvoiceList = async (type, event = {}, query = "", UserId) => {
    try {
      let params = {
        UserId: userId || UserId,
        POSStatus: type,
        page: event.first ? event.first / rowsPerPage : 0,
        limit: event.rows || rowsPerPage,
        Query: query || "",
      };
      api
        .post(APIConstant.path.GetLatestInvoiceList, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            // if (response.Data.length) {
            // let tempProductList = [
            //   ...productList,
            //   ...response.Data.ProductList,
            // ];
            // const mergedProducts = {};
            // (tempProductList || []).forEach((item) => {
            //   const key = `${item.ProductId}-${item.UnitId}-${item.BrandId}-${item.SubCategory}-${item.Rate}-${item.Mrp}`;

            //   if (!mergedProducts[key]) {
            //     mergedProducts[key] = { ...item };
            //   } else {
            //     mergedProducts[key].Quantity += Number(item.Quantity || 0);
            //     mergedProducts[key].SubTotal += Number(item.SubTotal || 0);
            //   }
            // });
            // setProductList(Object.values(mergedProducts));

            setAddPastDataListDialog(true);
            setPastDataList(response.Data);
            setListType(type);
            setTotalRecords(response.TotalRecords || 0);
            setFirst(event.first || 0);
            // }
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const GetRenderTemplate = async (Data, Type) => {
    try {
      let paramData = {
        UserId: userId,
        PrintData: Data,
        ConfigurationName: "Billing Configuration",
        Type,
      };
      await api
        .post(APIConstant.path.GetRenderTemplate, paramData)
        .then(async (response) => {
          if (response.Success === 1) {
            setTemplateHtml(response.Html);
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const handlePrintBill = async () => {
    try {
      const configMap = {};
      (barcodeConfig?.ConfigValue || []).forEach((item) => {
        configMap[item.value] = item.checked;
      });
      const response = await fetch("http://localhost:3333/print-bill", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PrintData: printData,
          ConfigMap: configMap,
          Content: content,
        }),
      });

      const result = await response.json();

      if (result.Success === 1) {
        cogoToast.success(result.Message || "Printed successfully");
      } else {
        cogoToast.error(result.Message || "Print failed");
      }
    } catch (err) {
      console.error(err);
      cogoToast.error(
        "Local printer service not running. Please start the printer service.",
      );
    }
  };

  const handlePrint = async (
    customerData,
    productData,
    response,
    serviceCharges,
  ) => {
    const gstWiseList = productData.reduce((acc, item) => {
      const gst = item.GstName || "";
      if (!acc[gst]) {
        acc[gst] = [];
      }
      acc[gst].push(item);
      return acc;
    }, {});

    let tempData = {
      IsGst: !billDetails.billType,
      IsInclusive: !billDetails.inclusion,
      SalesType: billDetails.salesType ? "INTERSTATE" : "INTRA-STATE",
      BusinessType: billDetails.businessType ? "B2B" : "B2C",
      CustomerDetails: {
        ...customerData,
        CustomerName: customerList.find(
          (cs) => cs.value === customerData.Customer,
        )?.label,
      },
      Discount: discountConfig,
      PrintDate: new Date(),
      ProductList: productData,
      GstWiseProductList: gstWiseList,
      BillNo: response.BillNo,
      ServiceCharges: serviceCharges,
    };

    setPrintData(tempData);

    await GetRenderTemplate(tempData, "Billing Template");

    // if (printButtonRef) {
    //   printButtonRef.current.click();
    // }
    setPreviewDialog(true);
  };
  const handleInvoicePrint = async (data) => {
    const gstWiseList = data.ProductList.reduce((acc, item) => {
      const gst = item.GstName || "";
      if (!acc[gst]) {
        acc[gst] = [];
      }
      acc[gst].push(item);
      return acc;
    }, {});

    let tempData = {
      IsGst: data.IsGst,
      IsInclusive: data.IsInclusive,
      PrintDate: new Date(),
      CustomerDetails: {
        Date: data.POSDate,
        ContactNo: data.ContactNo,
        CustomerName: data.CustomerName,
      },
      ProductList: data.ProductList,
      GstWiseProductList: gstWiseList,
      BillNo: data.BillNo,
      PaymentMode: data.PaymentMode,
      SalesType: data.SalesType,
      BusinessType: data.BusinessType,
    };

    setPrintData(tempData);

    await GetRenderTemplate(tempData, "Billing Template");

    // if (printButtonRef) {
    //   printButtonRef.current.click();
    // }
    setPreviewDialog(true);
  };

  const handleAddFromBarcodeDialog = () => {
    if (selectedBarcodeVariants.length === 0) {
      cogoToast.error("Please select at least one variant.");
      return;
    }

    const itemsToAdd = selectedBarcodeVariants
      .map((variant) => {
        if (!variant.qty || variant.qty <= 0) {
          return null;
        }

        const rate = variant.Batch?.Rate || variant.Price;
        const mrp = variant.Batch?.Mrp || variant.Mrp;

        return {
          _id: variant.VariantId,
          ProductId: variant.VariantId,
          Product: variant.Name,
          UnitId: variant.Unit,
          UnitName: variant.UnitName,
          WeightVolume: variant.WeightVolume,
          BrandId: barcodeParentItem.Brand,
          BrandName: barcodeParentItem.BrandName,
          HSNCodeName: barcodeParentItem.HSNCodeName,
          SubCategory: barcodeParentItem.SubCategory,
          SubCategoryName: barcodeParentItem.SubCategoryName,
          Category: barcodeParentItem.Category,
          CategoryName: barcodeParentItem.CategoryName,
          Quantity: variant.qty,
          Mrp: mrp,
          Rate: rate,
          GstName: barcodeParentItem.GstName,
          SubTotal: variant.qty * (rate || mrp),
          BatchId: variant.Batch?._id,
        };
      })
      .filter(Boolean); // remove nulls for items with no quantity

    if (itemsToAdd.length === 0) {
      cogoToast.error("Please enter a valid quantity for selected variants.");
      return;
    }

    let tempProductList = [...productList];

    itemsToAdd.forEach((newItem) => {
      const existingIndex = tempProductList.findIndex(
        (p) =>
          p._id === newItem._id &&
          p.Rate === newItem.Rate &&
          p.BatchId === newItem.BatchId,
      );

      if (existingIndex > -1) {
        tempProductList[existingIndex].Quantity += newItem.Quantity;
        tempProductList[existingIndex].SubTotal += newItem.SubTotal;
      } else {
        tempProductList.unshift(newItem);
      }
    });
    setProductList(tempProductList);
    setBarcodeVariantsDialog(false);
    setBarcodeVariants([]);
    setSelectedBarcodeVariants([]);
    setBarcodeParentItem(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (formData.Barcode) {
        GetVariantByBarcode(userId);
      }
    }
  };

  const DeletePOS = async (POSId, Index) => {
    try {
      let params = {
        UserId: userId,
        POSId,
      };
      api
        .post(APIConstant.path.DeletePOS, params)
        .then((response) => {
          setLoading(false);
          if (response.Success === 1) {
            cogoToast.success("Removed successfully from the list");
            let tempPastDataList = [...pastDataList];
            tempPastDataList.splice(Index, 1);
            setPastDataList(tempPastDataList);
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const validateCustomer = () => {
    let isValid = true;

    if (
      CommonConfig.isEmpty(customerDetails.CustomerName) &&
      CommonConfig.isEmpty(customerDetails.ContactNo)
    ) {
      cogoToast.error("Please enter customer name or contact no");
      isValid = false;
    }

    return isValid;
  };

  const validate = () => {
    let isValid = true;

    // let updatedFormData = { ...formData };

    // const formFieldsToValidate = [{ key: "Customer", label: "Customer Name" }];

    // formFieldsToValidate.forEach(({ key, label }) => {
    //   if (CommonConfig.isEmpty(updatedFormData[key])) {
    //     isValid = false;
    //     updatedFormData[`${key}Err`] = true;
    //     updatedFormData[`${key}ErrText`] = `${label} is required`;
    //   } else {
    //     updatedFormData[`${key}Err`] = false;
    //     updatedFormData[`${key}ErrText`] = "";
    //   }
    // });

    // setFormData(updatedFormData);

    if (!productList.length) {
      cogoToast.error("Please select items");
      isValid = false;
    } else {
      let qtyProductsLenth = productList.filter((pr) => !pr.Quantity)?.length;
      if (qtyProductsLenth) {
        cogoToast.error("Please enter Quantity");
        isValid = false;
      }
    }

    return isValid;
  };

  const handleScan = () => {};

  const validateStaff = () => {
    let isValid = true;

    let updatedStaff = { ...staffDetails };

    const formFieldsToValidate = [
      { key: "staff", label: "Staff Name" },
      { key: "pin", label: "Pin" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedStaff[key])) {
        isValid = false;
        updatedStaff[`${key}Err`] = true;
        updatedStaff[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedStaff[`${key}Err`] = false;
        updatedStaff[`${key}ErrText`] = "";
      }
    });

    setStaffDetails(updatedStaff);

    return isValid;
  };

  const handleUnlock = () => {
    if (validateStaff()) {
      try {
        let params = {
          UserId: userId,
          StaffId: staffDetails.staff,
          Pin: staffDetails.pin,
        };
        api
          .post(APIConstant.path.UnlockStaff, params)
          .then((response) => {
            if (response.Success === 1) {
              setLock(false);
              // setStaffDetails({
              //   staff: "",
              //   staffErr: false,
              //   staffErrText: "",
              //   pin: "",
              //   pinErr: "",
              //   pinErrText: "",
              // });
            }
          })
          .catch((err) => {});
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handleServiceChargeChange = (value, field, regex) => {
    if (!value) {
      setServiceCharge((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        setServiceCharge((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };
  const handleStaffChange = (value, field, regex) => {
    if (!value) {
      setStaffDetails((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        setStaffDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleleftToggle = () => {
    setOpenleft(!openleft);
  };

  const handleAddToList = (item, qty, rate, type) => {
    let existing = productList.find((product) => product._id === item.value);

    // if (existing) {

    //     cogoToast.error("Item already added to the list");

    // } else
    if (qty <= 0) {
      cogoToast.error("Please enter quantity");
    } else {
      let tempProductList = [...productList];
      let qtyAvailable = 0;
      if (type === "barcode") {
        let selectedBatch = item.Variant?.Batches.find(
          (batch) => batch.Barcode === formData.Barcode,
        );

        if (!selectedBatch) {
          selectedBatch = item.Variant?.Batches?.[0];
        }
        let Mrp = selectedBatch?.Mrp || item.Variant?.Price;
        let existingIndex = productList.findIndex(
          (product) =>
            product._id === item.value &&
            (product.Mrp === Mrp && product.Rate === selectedBatch?.Rate),
        );

        if (existingIndex >= 0) {
          let newQty = tempProductList[existingIndex].Quantity + qty;
          tempProductList[existingIndex].Quantity = newQty;
          tempProductList[existingIndex].SubTotal =
            newQty *
            (tempProductList[existingIndex].Rate ||
              tempProductList[existingIndex].Mrp);
        } else {
          tempProductList.unshift({
            _id: item.value,
            ProductId: item.value,
            Product: item.Variant.Name,
            UnitId: item.Variant.Unit || "",
            UnitName: item.Variant.UnitName,
            WeightVolume: item.Variant.WeightVolume,
            BrandId: item.Brand || "",
            BrandName: item.BrandName,
            HSNCodeName: item.HSNCodeName,
            SubCategory: item.SubCategory || "",
            SubCategoryName: item.SubCategoryName,
            Category: item.Category,
            CategoryName: item.CategoryName,
            Quantity: qty,
            Mrp: Mrp,
            Rate: selectedBatch?.Rate,
            GstName: item.GstName,
            SubTotal: qty * (selectedBatch?.Rate || Mrp),
          });
        }
        setProductList(tempProductList);
        setSelectedCardItem(null);
        setSelectedCardItemType("");
        setQty(1);
      } else if (item.value === selectItemDialogData.value) {
        if (
          selectedBatchItem &&
          selectItemDialogData.BatchQty[selectedBatchItem]
        ) {
          qtyAvailable =
            selectItemDialogData.BatchQty[selectedBatchItem].Quantity;
        }

        let Mrp = selectItemDialogData.BatchQty[selectedBatchItem].Mrp;

        let tempQty = qty;
        let batchDetails = Object.values(selectItemDialogData.BatchQty);

        // Step 1: Prioritize selected batch
        const selectedBatch = batchDetails.find(
          (batch) => batch.BatchId === selectedBatchItem,
        );
        if (selectedBatch) {
          let addQuantity =
            selectedBatch.Quantity >= tempQty
              ? tempQty
              : selectedBatch.Quantity;
          tempProductList.unshift({
            _id: item.value,
            BatchId: selectedBatch.BatchId,
            ProductId: item.value,
            Product: item.Variant.Name,
            UnitId: item.Variant.Unit || "",
            UnitName: item.Variant.UnitName,
            WeightVolume: item.Variant.WeightVolume,
            BrandId: item.Brand || "",
            BrandName: item.BrandName,
            HSNCodeName: item.HSNCodeName,
            SubCategory: item.SubCategory || "",
            SubCategoryName: item.SubCategoryName,
            Category: item.Category,
            CategoryName: item.CategoryName,
            Quantity: addQuantity,
            Mrp: selectedBatch.Mrp,
            Rate: selectedBatch.Rate,
            GstName: item.GstName,
            SubTotal: addQuantity * (selectedBatch.Rate || selectedBatch.Mrp),
          });
          tempQty -= addQuantity;
        }

        // Step 2: Consume remaining qty from other batches
        if (tempQty > 0) {
          batchDetails
            .filter((batch) => batch.BatchId !== selectedBatchItem)
            .forEach((batch) => {
              if (tempQty <= 0) return;

              let addQuantity =
                batch.Quantity >= tempQty ? tempQty : batch.Quantity;
              tempProductList.unshift({
                _id: item.value,
                BatchId: batch.BatchId,
                ProductId: item.value,
                Product: item.Variant.Name,
                UnitId: item.Variant.Unit || "",
                UnitName: item.Variant.UnitName,
                WeightVolume: item.Variant.WeightVolume,
                BrandId: item.Brand || "",
                BrandName: item.BrandName,
                HSNCodeName: item.HSNCodeName,

                SubCategory: item.SubCategory || "",
                SubCategoryName: item.SubCategoryName,
                Category: item.Category,
                CategoryName: item.CategoryName,
                Quantity: addQuantity,
                Mrp: batch.Mrp,
                Rate: batch.Rate,
                GstName: item.GstName,
                SubTotal: addQuantity * (batch.Rate || batch.Mrp),
              });
              tempQty -= addQuantity;
            });
        }

        if (tempQty > 0 && allowNegativeStock) {
          let index = tempProductList.findIndex(
            (product) => product.BatchId === selectedBatchItem,
          );
          tempProductList[index].Quantity += tempQty;
        } else if (tempQty > 0) {
          cogoToast.error("Quantity exceeds the warehouse limit");
          return;
        }
        // }
        setProductList(tempProductList);
        setSelectedCardItem(null);
        setSelectedCardItemType("");
        setQty(1);
        setSelectedBatchItem(null);
        setSelectItemDialogData({});
      } else {
        let Mrp = item.Variant?.Batches?.[0]?.Mrp || item.Variant?.Price;
        let existingIndex = productList.findIndex(
          (product) =>
            product._id === item.value &&
            (product.Mrp === Mrp && product.Rate === rate),
        );
        if (existingIndex >= 0) {
          tempProductList[existingIndex].Quantity = qty;
          tempProductList[existingIndex].SubTotal = qty * (rate || Mrp);
        } else {
          tempProductList.unshift({
            _id: item.value,
            ProductId: item.value,
            Product: item.Variant.Name,
            UnitId: item.Variant.Unit || "",
            UnitName: item.Variant.UnitName,
            WeightVolume: item.Variant.WeightVolume,
            BrandId: item.Brand || "",
            BrandName: item.BrandName,
            HSNCodeName: item.HSNCodeName,

            SubCategory: item.SubCategory || "",
            SubCategoryName: item.SubCategoryName,
            Category: item.Category,
            CategoryName: item.CategoryName,
            Quantity: qty,
            Mrp: Mrp,
            Rate: rate,
            GstName: item.GstName,
            SubTotal: qty * (rate || Mrp),
          });
        }
        setProductList(tempProductList);
        setSelectedCardItem(null);
        setSelectedCardItemType("");
        setQty(1);
      }
      handleClose("QuantityPopup");
    }
  };

  const handleAddListToList = (tempList) => {
    let addList = tempList.ProductList || recentDataList;
    if (tempList.POSStatus === "Draft") {
      setPosId(tempList._id);
      setBillNo(tempList.BillNo);
    }
    if (addList.length && !billNo) {
      let tempProductList = [...addList, ...productList];
      const mergedProducts = {};
      tempProductList.forEach((item) => {
        const key = `${item.ProductId}-${item.UnitId}-${item.BrandId}-${item.SubCategory}-${item.Rate}-${item.Mrp}`;
        if (parseInt(item.Quantity)) {
          if (!mergedProducts[key]) {
            mergedProducts[key] = { ...item };
          } else {
            mergedProducts[key].Quantity += Number(item.Quantity || 0);
            mergedProducts[key].SubTotal += Number(item.SubTotal || 0);
          }
        }
      });
      setProductList(Object.values(mergedProducts));
      if (tempList) {
        setFormData((prevState) => ({
          ...prevState,
          Customer: tempList.Customer,
          ContactNo: tempList.ContactNo,
        }));
        handleClose("PastDataList");
      } else {
        handleClose("RecentList");
      }
      if (latestDetails.Customer) {
        setFormData((prevState) => ({
          ...prevState,
          Customer: latestDetails.Customer,
          ContactNo: latestDetails.ContactNo,
        }));
      }
    } else {
      cogoToast.error("Draft Bill already added");
    }
  };

  const handleCustomerChange = (value, field, regex) => {
    if (!value) {
      setCustomerDetails((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        setCustomerDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleBillDetailsChange = (type, value) => {
    let tempBillDetails = { ...billDetails };
    tempBillDetails[type] = value;
    setBillDetails(tempBillDetails);

    AddUpdateAccountConfigurationData(tempBillDetails);
  };

  const handleFormChange = (value, field, regex) => {
    if (!value) {
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        if (field === "Barcode") {
          value = value.toUpperCase();
        }
        if (field === "Customer") {
          extraObj.ContactNo = customerList.find(
            (cu) => cu.value === value,
          )?.CustomerDetails?.ContactNo;
        }
        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleClose = (type) => {
    if (type === "Customer") {
      setCustomerDetails(initialCustomerDetails);
      setAddCustomerDialog(false);
    } else if (type === "RecentList") {
      setAddRecentListDialog(false);
      setRecentDataList([]);
      setLatestDetails({});
    } else if (type === "PastDataList") {
      setAddRecentListDialog(false);
      setRecentDataList([]);
      setLatestDetails({});
      setAddPastDataListDialog(false);
      setPastDataList([]);
      setListType("");
    } else if (type === "ItemDialog") {
      setSelectItemDialog(false);
      setSelectItemDialogData({});
      setSelectedBatchItem(null);
    } else if (type === "QuantityPopup") {
      setQuantityPopupDetails({
        open: false,
        Quantity: "",
        QuantityErr: false,
        QuantityErrText: "",
      });
    } else if (type === "ServiceCharge") {
      setAddServiceChargeDialog(false);
      setServiceCharge({
        service: "",
        serviceErr: false,
        serviceErrText: "",
        amount: "",
        amountErr: false,
        amountErrText: "",
      });
    }
  };

  const calculateTotal = (tempList) => {
    let totalQuantity = 0;
    let totalItems = 0;
    let subTotal = 0;
    let grandTotal = 0;
    let list = tempList || productList;
    list.forEach((product) => {
      totalQuantity += Number(product.Quantity);
      totalItems += 1;
      subTotal += product.Mrp;
      grandTotal += parseFloat(product.SubTotal);
    });

    nonGstServiceCharges.forEach((charge) => {
      grandTotal += charge.Amount;
    });
    return {
      totalItems,
      totalQuantity,
      subTotal,
      grandTotal,
    };
  };

  const parseGstPercent = (gstName) => {
    const match = gstName?.match(/(\d+(\.\d+)?)%/);
    return match ? parseFloat(match[1]) : 0;
  };

  const calculateGstBreakup = (products, isInclusive) => {
    const rows = [];
    let totalTaxable = 0,
      totalSgst = 0,
      totalCgst = 0,
      totalAmount = 0;

    products.forEach((item, index) => {
      const gstPercent = parseGstPercent(item.GstName);
      const gstRate = gstPercent / 100;
      const amount = parseFloat(item.SubTotal || 0);
      const tax = isInclusive
        ? amount - amount / (1 + gstRate)
        : amount * gstRate;
      const taxable = isInclusive ? amount - tax : amount;
      const total = isInclusive ? amount : amount + tax;
      const sgst = tax / 2;
      const cgst = tax / 2;

      rows.push({
        sr: index + 1,
        taxable: taxable.toFixed(2),
        sgst: sgst.toFixed(2),
        cgst: cgst.toFixed(2),
        total: total.toFixed(2),
      });

      totalTaxable += taxable;
      totalSgst += sgst;
      totalCgst += cgst;
      totalAmount += total;
    });

    return {
      rows,
      totals: {
        taxable: totalTaxable.toFixed(2),
        sgst: totalSgst.toFixed(2),
        cgst: totalCgst.toFixed(2),
        total: totalAmount.toFixed(2),
      },
    };
  };

  const calculateSummary = (products, isInclusive) => {
    let totalItems = products.length;
    let totalQuantity = 0;
    let totalAmount = 0;

    products.forEach((item) => {
      const qty = parseFloat(item.Quantity || 0);
      const base = parseFloat(item.SubTotal || 0);
      const gstPercent = parseGstPercent(item.GstName);
      const gstRate = gstPercent / 100;
      const tax = isInclusive ? base - base / (1 + gstRate) : base * gstRate;
      const finalAmount = isInclusive ? base : base + tax;

      totalQuantity += qty;
      totalAmount += finalAmount;
    });

    return {
      totalItems,
      totalQuantity: totalQuantity.toFixed(3),
      totalAmount: totalAmount.toFixed(2),
    };
  };

  const handleServiceChargeSubmit = () => {
    if (validateServiceCharge()) {
      const selectedService = serviceChargesList.find(
        (s) => s.value === serviceCharge.service,
      );
      if (selectedService.IsGst) {
        // Add to product list
        const serviceItem = {
          _id: selectedService.value,
          ProductId: selectedService.value,
          Product: selectedService.label,
          UnitId: "",
          UnitName: "",
          WeightVolume: "",
          BrandId: "",
          BrandName: "",
          HSNCodeName: selectedService.HSNCodeName || "",
          SubCategory: "",
          SubCategoryName: "",
          Category: "",
          CategoryName: "",
          Quantity: 1,
          Mrp: parseFloat(serviceCharge.amount),
          Rate: parseFloat(serviceCharge.amount),
          GstName: selectedService.GSTName || "",
          SubTotal: parseFloat(serviceCharge.amount),
          isServiceCharge: true, // Flag to identify service charge
        };
        setProductList((prev) => [serviceItem, ...prev]);
      } else {
        // Add to non-GST service charges list
        // setNonGstServiceCharges((prev) => [
        //   ...prev,
        //   { ...selectedService, Amount: parseFloat(serviceCharge.amount) },
        // ]);
        setNonGstServiceCharges([
          { ...selectedService, Amount: parseFloat(serviceCharge.amount) },
        ]);
      }
      handleClose("ServiceCharge");
    }
  };

  const addBatchItem = () => {
    if (selectedBatchItem) {
      let tempSortedItems = [...sortedItems];

      tempSortedItems = tempSortedItems.map((group) => ({
        ...group,
        Items: group.Items.map((item) => {
          if (item.value === selectItemDialogData.value) {
            let selectedbatchDetails = selectItemDialogData.list.find(
              (batchDetails) => batchDetails.value === selectedBatchItem,
            );
            return { ...item, SelectedRate: selectedbatchDetails.rate };
          }
          return item;
        }),
      }));

      setSortedItems(tempSortedItems);
      let tempFilteredSortedItems = [...filterSortedItems];

      tempFilteredSortedItems = tempFilteredSortedItems.map((group) => ({
        ...group,
        Items: group.Items.map((item) => {
          if (item.value === selectItemDialogData.value) {
            let selectedbatchDetails = selectItemDialogData.list.find(
              (batchDetails) => batchDetails.value === selectedBatchItem,
            );
            return { ...item, SelectedRate: selectedbatchDetails.rate };
          }
          return item;
        }),
      }));

      setFilterSortedItems(tempFilteredSortedItems);
      setSelectItemDialog(false);
    } else {
      cogoToast.error("Please select batch");
    }
  };

  const validateServiceCharge = () => {
    let isValid = true;
    let updatedServiceCharge = { ...serviceCharge };

    if (CommonConfig.isEmpty(serviceCharge.service)) {
      isValid = false;
      updatedServiceCharge.serviceErr = true;
      updatedServiceCharge.serviceErrText = "Please select a service charge";
    }
    if (
      CommonConfig.isEmpty(serviceCharge.amount) ||
      parseFloat(serviceCharge.amount) <= 0
    ) {
      isValid = false;
      updatedServiceCharge.amountErr = true;
      updatedServiceCharge.amountErrText = "Please enter a valid amount";
    }
    setServiceCharge(updatedServiceCharge);
    return isValid;
  };
  const handleItemClick = (item) => {
    setSelectedCardItem(item);
  };

  const onPin = (item) => {
    if (pinnedItems.length <= 5) {
      let existing = pinnedItems.find(
        (pinnedItem) => pinnedItem.value === item.value,
      );
      if (!existing) {
        let tempPinnedItems = [...pinnedItems];
        item.IsPinned = true;
        tempPinnedItems.push(item);
        setPinnedItems(tempPinnedItems);
        AddPinnedItem(tempPinnedItems);
      }
    }
  };

  const UnPin = (item) => {
    let existing = pinnedItems.find(
      (pinnedItem) => pinnedItem.value === item.value,
    );
    if (existing) {
      const updatedPinnedItems = pinnedItems.filter(
        (pinnedItem) => pinnedItem.value !== item.value,
      );
      item.IsPinned = false;
      setPinnedItems(updatedPinnedItems);
      AddPinnedItem(updatedPinnedItems);
    }
  };

  const availableQtyMap = useMemo(() => {
    const map = new Map();
    (itemStockList || []).forEach((stock) => {
      let qty = 0;
      if (stock.BatchQuantityDetails?.length) {
        stock.BatchQuantityDetails.forEach((batch) => {
          if (selectedWarehouse.includes(batch.SubWarehouseId)) {
            qty += batch.Quantity;
          }
        });
      }
      if (stock.QuantityDetails?.length) {
        stock.QuantityDetails.forEach((q) => {
          if (selectedWarehouse.includes(q.SubWarehouseId)) {
            qty += q.Quantity;
          }
        });
      }
      map.set(stock.ItemId, qty);
    });
    return map;
  }, [itemStockList, selectedWarehouse]);

  const getAvailableQuantity = (item) =>
    availableQtyMap.get(item.value)
      ? availableQtyMap.get(item.value).toFixed(3)
      : 0;

  const selectedRateMap = useMemo(() => {
    const map = new Map();
    (filterSortedItems || []).forEach((group) => {
      (group.Items || []).forEach((it) => {
        if (it.SelectedRate) map.set(it.value, it.SelectedRate);
      });
    });
    return map;
  }, [filterSortedItems]);

  useEffect(() => {
    try {
      listCacheRef.current.clearAll();
      if (listRef.current && listRef.current.recomputeRowHeights) {
        listRef.current.recomputeRowHeights();
      }
    } catch (e) {}
  }, [open, search, filterSortedItems]);

  const ItemCard = (props) => (
    <POSItemCard
      {...props}
      itemStockList={itemStockList}
      selectedWarehouse={selectedWarehouse}
      userPageAccess={userPageAccess}
      onPin={onPin}
      UnPin={UnPin}
      selectItemDialogData={selectItemDialogData}
      setSelectItemDialog={setSelectItemDialog}
      setSelectItemDialogData={setSelectItemDialogData}
      setSelectedCardItem={setSelectedCardItem}
      setSelectedCardItemType={setSelectedCardItemType}
      handleAddToList={handleAddToList}
      getAvailableQuantity={getAvailableQuantity}
      selectedRateMap={selectedRateMap}
    />
  );

  const actionTemplate = (rowData, props) => {
    return (
      <div className="icon-only-btn">
        <div
          onClick={(e) => {
            let tempRecentDataList = [...recentDataList];
            tempRecentDataList.splice(props.rowIndex, 1);
            setRecentDataList(tempRecentDataList);
          }}
        >
          <i class="icon-delete"></i>
        </div>
      </div>
    );
  };

  const actionBodyTemplate = (rowData, props) => {
    return (
      <div className="icon-only-btn p-d-flex p-ai-center">
        <i
          class="icon-view"
          onClick={(e) => {
            setRecentDataList(rowData.ProductList);
            setAddRecentListDialog(true);
          }}
        ></i>

        <i
          class="icon-add"
          onClick={(e) => {
            handleAddListToList(rowData);
          }}
        ></i>
        {listType === "Draft" && (
          <i
            class="icon-delete"
            onClick={(e) => {
              DeletePOS(rowData._id, props.rowIndex);
            }}
          ></i>
        )}
      </div>
    );
  };

  const onPageChange = (e) => {
    setRowsPerPage(e.rows);
    GetLatestInvoiceList(listType, e, dialogSearch);
  };

  const handleRowClick = (e) => {
    const { _id } = e.data;
    const currentTime = new Date().getTime();

    // Create or update click data for the specific row
    const newClickData = { ...clickData };
    if (!newClickData[_id]) {
      newClickData[_id] = { count: 1, lastClickTime: currentTime };
    } else {
      const timeSinceLastClick = currentTime - newClickData[_id].lastClickTime;
      if (timeSinceLastClick < 1000) {
        // If within 1 second
        newClickData[_id].count += 1;
      } else {
        // Reset count if time limit exceeded
        newClickData[_id].count = 1;
      }
      newClickData[_id].lastClickTime = currentTime;
    }

    // Check if count has reached 3
    if (newClickData[_id].count === 3 && !readOnly) {
      deleteRow(e); // Replace with your delete function
      newClickData[_id].count = 0; // Reset the count after deletion
    }

    setClickData(newClickData); // Update the state
  };

  const deleteRow = (data) => {
    // let index = data.index;
    let index = productList.findIndex((item) => item._id === data.data._id);
    let tempProductList = [...productList];
    tempProductList.splice(index, 1);
    setProductList(tempProductList);
  };

  const handleQuantitySubmit = () => {
    if (CommonConfig.isEmpty(quantityPopupDetails.Quantity)) {
      setQuantityPopupDetails((prevState) => ({
        ...prevState,
        QuantityErr: true,
        QuantityErrText: "Quantity is required",
      }));
    } else {
      //  onClick={() => handleAddToList(item, qty, rate)}
      //  setSelectedCardItem(response.Data);
      //       setSelectedCardItemType("normal");
      let rate =
        selectedCardItem.Batch?.Rate ||
        selectedCardItem?.Variant?.Price ||
        selectedCardItem?.Variant?.Batches?.[0]?.Rate;
      handleAddToList(selectedCardItem, quantityPopupDetails.Quantity, rate);
    }
  };
  const itemTable = () => {
    return (
      <DataTable
        className="main-table table-td e-c-table e-pos-table"
        value={productList}
        totalRecords={productList.length}
        emptyMessage="No records found"
        responsiveLayout="scroll"
        editMode="row"
        dataKey="id"
        globalFilter={search}
        responsive={false}
        resizableColumns={true}
        columnResizeMode="fit"
        scrollabel={true}
        onRowClick={(e) => handleRowClick(e)}
        scrollWidth="auto"
      >
        <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
        <Column
          field="Product"
          header="Product"
          className="e-text-one-line"
          body={(rowData) => {
            let productName = rowData.Product;
            if (rowData.WeightVolume || rowData.UnitName || rowData.BrandName) {
              productName += " (";
            }
            if (rowData.WeightVolume) {
              productName += " " + rowData.WeightVolume;
            }
            if (rowData.UnitName) {
              productName += " " + rowData.UnitName;
            }
            if (rowData.BrandName) {
              productName += " - " + rowData.BrandName;
            }
            if (rowData.WeightVolume || rowData.UnitName || rowData.BrandName) {
              productName += ")";
            }
            return productName;
          }}
        />
        <Column
          field="Quantity"
          header="Qty"
          body={(rowData, props) => (
            <div
              ref={(el) => (wrapperRefs.current[props.rowIndex] = el)}
              // style={{ position: "relative", display: "inline-block" }}
            >
              <InputText
                disabled={rowData.isServiceCharge}
                value={rowData.Quantity}
                onChange={(e) => {
                  let tempList = [...productList];
                  // Keep your original regex validation
                  if (
                    /^\d*\.?\d*$/i.test(e.target.value) ||
                    e.target.value === 0
                  ) {
                    let value = e.target.value;
                    tempList[props.rowIndex].Quantity = value;
                    if (value) {
                      tempList[props.rowIndex].SubTotal = (
                        value * (rowData.Rate || rowData.Mrp)
                      ).toFixed(2);
                    } else {
                      tempList[props.rowIndex].SubTotal = 0;
                    }
                    setProductList(tempList);
                  }
                }}
                onFocus={(e) => {
                  e.target.select();
                  setActiveRowIndex(props.rowIndex); // open keypad for this row
                }}
                style={{ maxWidth: "80px", textAlign: "center" }}
                maxLength={5}
              />
              {activeRowIndex === props.rowIndex && (
                <NumericKeypadDropdown
                  anchorRef={{ current: wrapperRefs.current[props.rowIndex] }}
                  onSelect={(val) => {
                    let tempList = [...productList];
                    tempList[props.rowIndex].Quantity = String(val);
                    tempList[props.rowIndex].SubTotal = (
                      val * (rowData.Rate || rowData.Mrp)
                    ).toFixed(2);
                    setProductList(tempList);
                    setActiveRowIndex(null); // close after selection
                  }}
                  onClose={() => setActiveRowIndex(null)}
                />
              )}
            </div>
          )}
        />
        <Column field="Mrp" header="Mrp" />
        <Column field="Rate" header="Rate" />
        <Column field="SubTotal" header="SubTotal" />
      </DataTable>
    );
  };
  let configList = barcodeConfig
    .filter((config) => config.checked)
    .map((config) => config.value);

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-pos-form">
      <div className="p-grid">
        {open ? (
          <div className="p-sm-6">
            <div className="heading-area tab-container">
              <div className="p-d-flex p-ai-center">
                <Button
                  className="menu-button"
                  justIcon
                  aria-label="open drawer"
                  onClick={handleleftToggle}
                >
                  <i className="icon-menu"></i>
                </Button>

                <div className="toggle-group">
                  {isStaffAccess && (
                    <Tooltip title="Lock this screen">
                      <span onClick={() => setLock(true)}>
                        {lock ? (
                          <i className="pi pi-lock" />
                        ) : (
                          <i className="pi pi-unlock" />
                        )}
                      </span>
                    </Tooltip>
                  )}
                  <div className="pill-toggle">
                    <ToggleButton
                      onLabel="GST"
                      offLabel="NON-GST"
                      checked={!billDetails.billType}
                      onChange={(e) =>
                        handleBillDetailsChange("billType", !e.value)
                      }
                      className={!billDetails.billType ? "active" : ""}
                    />
                  </div>
                  <div className="pill-toggle">
                    <ToggleButton
                      disabled={!!billDetails.billType}
                      onLabel="Inclusive"
                      offLabel="Non-Inclusive"
                      checked={!billDetails.inclusion}
                      onChange={(e) =>
                        handleBillDetailsChange("inclusion", !e.value)
                      }
                      className={!billDetails.inclusion ? "active" : ""}
                    />
                  </div>

                  <div className="pill-toggle">
                    <ToggleButton
                      onLabel="Upfront Payment"
                      offLabel="Credit"
                      checked={billDetails.payment}
                      onChange={(e) =>
                        handleBillDetailsChange("payment", e.value)
                      }
                      className={billDetails.payment ? "active" : ""}
                    />
                  </div>

                  {isStaffAccess &&
                  staffDetails.staff &&
                  staffList.length &&
                  !lock ? (
                    <div className="">
                      (
                      {
                        staffList.find(
                          (staff) => staff.value === staffDetails.staff,
                        )?.label
                      }
                      )
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div style={{ display: "block", width: "100%" }}>
                <div className="toggle-group">
                  <div className="pill-toggle">
                    <ToggleButton
                      onLabel="INTERSTATE"
                      offLabel="INTRA-STATE"
                      checked={billDetails.salesType}
                      onChange={(e) =>
                        handleBillDetailsChange("salesType", e.value)
                      }
                      className={billDetails.salesType ? "active" : ""}
                    />
                  </div>
                  <div className="pill-toggle">
                    <ToggleButton
                      onLabel="B2B"
                      offLabel="B2C"
                      checked={billDetails.businessType}
                      onChange={(e) =>
                        handleBillDetailsChange("businessType", e.value)
                      }
                      className={billDetails.businessType ? "active" : ""}
                    />
                  </div>
                </div>
              </div>
              <div>
                <MultiSelect
                  value={selectedWarehouse}
                  onChange={(e) => {
                    setSelectedWarehouse(e.target.value);
                    AddUpdateAccountConfiguration(e.target.value);
                  }}
                  options={warehouseList}
                  optionLabel="label"
                  placeholder="Select Warehouse"
                  className="p-w-100"
                  disabled={readOnly}
                />
              </div>
              <div>
                <Dropdown
                  filter
                  options={paymentModeList}
                  value={billDetails.paymentMode.id}
                  onChange={(e) => {
                    let label =
                      paymentModeList.find((pm) => pm.value === e.value)
                        ?.label || "";

                    let tempBillDetails = { ...billDetails };
                    tempBillDetails.paymentMode = { id: e.value, label };
                    setBillDetails(tempBillDetails);
                    AddUpdateAccountConfigurationData(tempBillDetails);
                  }}
                  placeholder="Payment Mode"
                  className="custom-input p-w-100"
                />
              </div>

              {/* <div className="action-buttons">
                <button type="button" className="primary-button">
                  <i className="pi pi-plus" /> Item
                </button>
                <button type="button" className="primary-button">
                  <i className="pi pi-plus" /> Service
                </button>
              </div> */}
            </div>
            <div className="container-body e-container-body e-pos-body">
              <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
                <div className="form-pos-grid">
                  {/* Row 1 - Name, Date, Plus */}
                  <div className="form-row">
                    <div className="field full">
                      <Dropdown
                        filter
                        options={customerList}
                        value={formData.Customer}
                        onChange={(e) => handleFormChange(e.value, "Customer")}
                        placeholder="Enter Name"
                        className="custom-input"
                      />
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.CustomerErr ? formData.CustomerErrText : null}
                      </span>
                    </div>
                    <div className="field full">
                      <div className="p-d-flex">
                        <Datetime
                          value={moment(formData.Date)}
                          onChange={(date) => handleFormChange(date, "Date")}
                          closeOnSelect
                          renderInput={(params) => (
                            <input
                              {...params}
                              placeholder="DD/MM/YYYY"
                              className="custom-input"
                            />
                          )}
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                        />
                        <div className="p-ml-2 field icon-button">
                          <button
                            type="button"
                            onClick={() => setAddCustomerDialog(true)}
                          >
                            <i className="pi pi-plus" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row 2 - Contact, Barcode */}
                  <div className="form-row">
                    <div className="field full">
                      <input
                        type="text"
                        className="custom-input"
                        placeholder="+91-XXXXXXXXXXXX"
                        value={formData.ContactNo}
                        onChange={(e) =>
                          handleFormChange(
                            e.target.value,
                            "ContactNo",
                            /^\d*$/i,
                          )
                        }
                        maxLength={10}
                      />
                    </div>

                    <div className="field full">
                      <div className="field barcode">
                        <i className="pi pi-qrcode" />
                        <input
                          autoFocus
                          type="text"
                          className="custom-input with-icon p-pl-0"
                          placeholder="Bar Code"
                          value={formData.Barcode}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "Barcode")
                          }
                          onKeyDown={(e) => handleKeyDown(e)}
                          maxLength={50}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 3 - Search */}
                  <div className="search-row">
                    <i className="pi pi-search" />
                    <input
                      type="text"
                      className="custom-input search-input"
                      placeholder="Search"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              {openleft && itemTable()}
              <div className="summary-container">
                <div className="summary-row">
                  <div>Quantity</div>
                  <div>{calculateTotal().totalQuantity}</div>
                </div>
                <div className="summary-row">
                  <div>No. Of Items</div>
                  <div>{calculateTotal().totalItems}</div>
                </div>
                {nonGstServiceCharges.map((charge, index) => (
                  <div className="summary-row" key={index}>
                    <div>{charge.ServiceName}</div>
                    <div>₹{charge.Amount.toFixed(2)}</div>
                  </div>
                ))}
                <div className="summary-row subtotal">
                  <div>Subtotal</div>
                  <div>₹{calculateTotal().subTotal}</div>
                </div>
                <div className="summary-row grand-total">
                  <div>Grand Total</div>
                  <div>₹{calculateTotal().grandTotal}</div>
                </div>

                <div className="main-actions">
                  <button className="btn blue" onClick={GetLatestInvoiceData}>
                    Last Invoice
                  </button>
                  <button
                    className="btn blue"
                    onClick={(e) => GetLatestInvoiceData(e, "Print")}
                  >
                    Last Invoice Print
                  </button>
                  <button
                    className="btn red"
                    onClick={() => AddUpdatePOS(true)}
                  >
                    Save As Draft
                  </button>
                  <button
                    className="btn green"
                    onClick={() => AddUpdatePOS(false)}
                  >
                    Save & Print
                  </button>
                </div>

                <div className="pill-actions">
                  <button onClick={() => GetLatestInvoiceList("Draft")}>
                    Draft List
                  </button>
                  <button onClick={() => GetLatestInvoiceList("Completed")}>
                    Sale Bill List
                  </button>
                  <button onClick={() => setAddServiceChargeDialog(true)}>
                    Add Other Charges
                  </button>
                  <button>Credit Notes</button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {!openleft && <div className="p-sm-6">{itemTable()}</div>}

        <div className={!openleft ? "p-d-none" : open ? "p-sm-6" : "p-sm-12"}>
          {/* Toggle Buttons */}
          <div className="tab-container p-d-flex p-jc-between p-mb-3">
            {/* <Button
              className="p-mr-3 menu-button"
              justIcon
              aria-label="open drawer"
              onClick={handleDrawerToggle}
            >
              <i className="icon-menu"></i>
            </Button> */}

            <div>
              {["Item", "Brand", "Sub-Category"].map((label) => (
                <Button
                  key={label}
                  label={label}
                  className={`tab-button ${
                    selectedTab === label ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab(label)}
                />
              ))}
            </div>
            <div>
              <Button
                className="p-mr-3 menu-button"
                justIcon
                aria-label="open drawer"
                onClick={handleDrawerToggle}
              >
                <i className="icon-menu"></i>
              </Button>
            </div>
          </div>

          <div className="item-wrapper">
            {selectedTab === "Item" && (
              <>
                {/* Pinned & Recent Section */}
                <div
                  className="p-px-3 p-py-2 p-mb-2"
                  style={{
                    backgroundColor: "#d9e8ff",
                    borderRadius: "6px",
                    fontWeight: "600",
                  }}
                >
                  Pinned & Recent
                </div>
                <div className="p-grid p-mb-1 p-gap-2">
                  {pinnedItems.map((item) => (
                    <div
                      className={
                        open
                          ? "p-md-6 p-sm-12 p-col-12"
                          : "p-md-4 p-sm-4 p-col-6"
                      }
                      key={item._id}
                    >
                      <ItemCard
                        item={item}
                        icon="pi-thumbtack"
                        iconColor="#00BFA6"
                        type="pinned"
                        isSelected={
                          selectedCardItem &&
                          selectedCardItemTyper === "pinned" &&
                          item.value === selectedCardItem.value
                        }
                      />
                    </div>
                  ))}
                  {recentItems.map((item) => (
                    <div
                      className={
                        open
                          ? "p-md-6 p-sm-12 p-col-12"
                          : "p-md-4 p-sm-4 p-col-6"
                      }
                      key={item._id}
                    >
                      <ItemCard
                        item={item}
                        icon="pi-history"
                        iconColor="#00BFA6"
                        type="recent"
                        isSelected={
                          selectedCardItem &&
                          selectedCardItemTyper === "recent" &&
                          item.value === selectedCardItem.value
                        }
                      />
                    </div>
                  ))}
                </div>

                {/* Alphabetical List Section */}
                <div
                  style={{ height: "calc(100vh - 320px)", overflow: "hidden" }}
                >
                  <AutoSizer>
                    {({ width, height }) => {
                      const columnCount = open ? 2 : 3;
                      const headerHeight = 40;

                      // Build flattened rows: header row per group + multiple item rows
                      const rows = [];
                      (filterSortedItems || []).forEach((group) => {
                        if (!group.Items?.length) return;
                        rows.push({ type: "header", letter: group.letter });
                        const items = group.Items;
                        const rowCount = Math.ceil(items.length / columnCount);
                        for (let r = 0; r < rowCount; r++) {
                          const start = r * columnCount;
                          rows.push({
                            type: "items",
                            letter: group.letter,
                            start,
                            items: items.slice(start, start + columnCount),
                          });
                        }
                      });

                      const cache = listCacheRef.current;

                      const rowRenderer = ({ index, key, parent, style }) => {
                        const row = rows[index];
                        if (row.type === "header") {
                          return (
                            <div
                              key={key}
                              style={{
                                ...style,
                                height: headerHeight,
                                lineHeight: `${headerHeight}px`,
                              }}
                            >
                              <div
                                className="p-px-3 p-py-2"
                                style={{
                                  backgroundColor: "#d9e8ff",
                                  borderRadius: "6px",
                                  fontWeight: 600,
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {row.letter}
                              </div>
                            </div>
                          );
                        }
                        return (
                          <CellMeasurer
                            key={key}
                            cache={cache}
                            parent={parent}
                            columnIndex={0}
                            rowIndex={index}
                          >
                            {({ registerChild }) => (
                              <div ref={registerChild} style={style}>
                                <div className="p-grid p-mt-2 p-gap-2">
                                  {row.items.map((item, idx) => (
                                    <div
                                      className={
                                        open
                                          ? "p-md-6 p-sm-12 p-col-12"
                                          : "p-md-4 p-sm-4 p-col-6"
                                      }
                                      key={
                                        (item._id || item.value) +
                                        "-" +
                                        (row.start + idx)
                                      }
                                    >
                                      <ItemCard
                                        item={item}
                                        type="normal"
                                        isSelected={
                                          selectedCardItem &&
                                          selectedCardItemTyper === "normal" &&
                                          item.value === selectedCardItem.value
                                        }
                                        onRowChange={() => {
                                          try {
                                            cache.clear(index, 0);
                                            if (
                                              listRef.current &&
                                              listRef.current
                                                .recomputeRowHeights
                                            ) {
                                              listRef.current.recomputeRowHeights(
                                                index,
                                              );
                                            }
                                          } catch (e) {}
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </CellMeasurer>
                        );
                      };

                      return (
                        <List
                          ref={listRef}
                          width={width}
                          height={height}
                          rowCount={rows.length}
                          rowHeight={({ index }) => {
                            const row = rows[index];
                            if (row.type === "header") return headerHeight;
                            return cache.rowHeight({ index }) || 220;
                          }}
                          rowRenderer={rowRenderer}
                          overscanRowCount={5}
                        />
                      );
                    }}
                  </AutoSizer>
                </div>
              </>
            )}

            {selectedTab === "Brand" && (
              <div className="p-d-flex">
                <TieredMenu model={brandList} className="p-mr-2" />
                {selectedCardItem && (
                  <ItemCard
                    isSelected
                    isNotItemTab={true}
                    type="normal"
                    item={selectedCardItem}
                  />
                )}
              </div>
            )}
            {selectedTab === "Sub-Category" && (
              <div className="p-d-flex">
                <TieredMenu model={subCategoryList} className="p-mr-2" />
                {selectedCardItem && (
                  <ItemCard
                    isSelected
                    isNotItemTab={true}
                    type="normal"
                    item={selectedCardItem}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={addCustomerDialog}
        aria-labelledby="cha-form-dialog-title"
        onClose={() => handleClose("Customer")}
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Customer</div>

          <div className="dialog-close" onClick={(e) => handleClose("Add")}>
            <i className="icon-modal-close"></i>
          </div>
          {/* Add Customer
          <div className="cancel">
            <i className="pi pi-times"></i>
          </div> */}
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem xs={12}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-4">
                  <label className="input-text">Customer Name</label>
                  <InputText
                    autoFocus
                    className="p-w-100"
                    placeholder="Enter Customer Name"
                    value={customerDetails.CustomerName}
                    maxLength={50}
                    onChange={(e) =>
                      handleCustomerChange(e.target.value, "CustomerName")
                    }
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {customerDetails.CustomerNameErr
                      ? customerDetails.CustomerNameErrText
                      : null}{" "}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Mobile No */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">Mobile</label>
                  <InputText
                    className="p-w-100"
                    placeholder="Enter Mobile"
                    maxLength={10}
                    value={customerDetails.ContactNo}
                    onChange={(e) =>
                      handleCustomerChange(
                        e.target.value,
                        "ContactNo",
                        /^\d*$/i,
                      )
                    }
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {customerDetails.ContactNoErr
                      ? customerDetails.ContactNoErrText
                      : null}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Email ID */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">Email</label>
                  <InputText
                    className="p-w-100"
                    placeholder="Enter Email"
                    value={customerDetails.EmailId}
                    maxLength={80}
                    onChange={(e) =>
                      handleCustomerChange(e.target.value, "EmailId")
                    }
                  />
                </div>
              </div>
            </GridItem>

            {/* GST */}
            <GridItem xs={12}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">Company Name</label>
                  <InputText
                    className="p-w-100"
                    placeholder="Enter Company Name"
                    value={customerDetails.CompanyName}
                    maxLength={50}
                    onChange={(e) =>
                      handleCustomerChange(e.target.value, "CompanyName")
                    }
                  />
                </div>
              </div>
            </GridItem>

            {/* GST */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">GSTIN</label>
                  <InputText
                    className="p-w-100"
                    placeholder="Enter GSTIN"
                    value={customerDetails.GST}
                    maxLength={30}
                    onChange={(e) =>
                      handleCustomerChange(e.target.value, "GST")
                    }
                  />
                </div>
              </div>
            </GridItem>

            {/* State */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">State</label>
                  <InputText
                    className="p-w-100"
                    placeholder="Enter State"
                    value={customerDetails.State}
                    maxLength={30}
                    onChange={(e) =>
                      handleCustomerChange(e.target.value, "State")
                    }
                  />
                </div>
              </div>
            </GridItem>

            {/* Address */}
            <GridItem xs={12}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3 p-mb-4">
                  <label className="input-text">Address</label>
                  <InputText
                    className="p-w-100"
                    placeholder="Enter Address"
                    maxLength={300}
                    value={customerDetails.Address}
                    onChange={(e) =>
                      handleCustomerChange(e.target.value, "Address")
                    }
                  />
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </DialogContent>

        <DialogActions className="dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => handleClose("Customer")}
          >
            Cancel
          </Button>
          <Button className="primary-btn" onClick={AddUpdateNetwork}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={lock} aria-labelledby="cha-form-dialog-title">
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>🔒 POS Locked</div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem xs={12}>
              <div>
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">Staff Name</label>
                  <Dropdown
                    filter
                    options={staffList}
                    value={staffDetails.staff}
                    onChange={(e) => handleStaffChange(e.value, "staff")}
                    placeholder="Enter Name"
                    className="custom-input p-w-100"
                  />

                  <span className="error-msg" style={{ color: "red" }}>
                    {staffDetails.staffErr ? staffDetails.staffErrText : null}
                  </span>
                </div>
              </div>
            </GridItem>

            <GridItem xs={12}>
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng p-mt-3">
                  <label className="input-text">Pin</label>
                  <InputText
                    type="password"
                    placeholder="Enter Pin"
                    maxLength={10}
                    value={staffDetails.pin}
                    onChange={(e) =>
                      handleStaffChange(e.target.value, "pin", /^\d*$/i)
                    }
                    className="p-w-100"
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {staffDetails.pinErr ? staffDetails.pinErrText : null}
                  </span>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </DialogContent>

        <DialogActions className="dialog-footer1">
          <Button className="primary-btn" onClick={handleUnlock}>
            Unlock
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addPastDataListDialog}
        aria-labelledby="cha-form-dialog-title"
        onClose={() => handleClose("PastDataList")}
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          List
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area"></DialogContent>
        <div className="search-row">
          <i className="pi pi-search" />
          <input
            type="text"
            className="custom-input search-input"
            placeholder="Search"
            onChange={(e) => setDialogSearch(e.target.value)}
          />
        </div>
        <DataTable
          className="main-table table-td e-c-table"
          value={pastDataList}
          totalRecords={totalRecords}
          emptyMessage="No records found"
          responsiveLayout="scroll"
          editMode="row"
          dataKey="id"
          globalFilter={dialogSearch}
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollabel={true}
          scrollWidth="auto"
          paginator
          rows={rowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          lazy
          onPage={onPageChange}
          first={first}
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
          <Column field="CustomerName" header="Customer Name" />
          <Column field="ContactNo" header="Contact" />
          <Column
            field="Products"
            header="Products"
            body={(rowData, props) => {
              return rowData.ProductList.length;
            }}
          />

          <Column body={actionBodyTemplate} header="Actions" />
        </DataTable>
        <DialogActions className="dialog-footer">
          <Button
            className="btn cancel"
            onClick={() => handleClose("PastDataList")}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addRecentListDialog}
        aria-labelledby="cha-form-dialog-title"
        onClose={() => handleClose("RecentList")}
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          List
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area"></DialogContent>
        {latestDetails.Customer && (
          <div>
            <div>Customer Name: {latestDetails.CustomerName}</div>
            <div>COntact No: {latestDetails.ContactNo}</div>
          </div>
        )}
        <DataTable
          className="main-table table-td e-c-table"
          value={recentDataList}
          totalRecords={recentDataList.length}
          emptyMessage="No records found"
          responsiveLayout="scroll"
          editMode="row"
          dataKey="id"
          globalFilter={search}
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollabel={true}
          scrollWidth="auto"
        >
          <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
          <Column field="Product" header="Product" />
          <Column
            field="Quantity"
            header="Quantity"
            body={(rowData, props) => {
              return (
                <InputText
                  value={rowData.Quantity}
                  onChange={(e) => {
                    let tempList = [...recentDataList];
                    if (
                      /^\d*\.?\d*$/i.test(e.target.value) ||
                      e.target.value === 0
                    ) {
                      tempList[props.rowIndex].Quantity = e.target.value;
                      if (e.target.value) {
                        tempList[props.rowIndex].SubTotal = (
                          parseInt(e.target.value) *
                          (rowData.Mrp + (rowData.Mrp * rowData.Rate) / 100)
                        ).toFixed(2);
                      } else {
                        tempList[props.rowIndex].SubTotal = 0;
                      }
                      setRecentDataList(tempList);
                    }
                  }}
                  maxLength={8}
                />
              );
            }}
          />
          <Column field="Mrp" header="Mrp" />
          <Column field="Rate" header="Rate" />
          <Column field="SubTotal" header="SubTotal" />
          {/* <Column body={actionTemplate} header="Actions" /> */}
        </DataTable>
        <DialogActions className="dialog-footer">
          <Button
            className="btn cancel"
            onClick={() => handleClose("RecentList")}
          >
            Cancel
          </Button>
          <Button
            className="btn submit"
            color="primary"
            onClick={handleAddListToList}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={selectItemDialog}
        aria-labelledby="cha-form-dialog-title"
        onClose={() => handleClose("ItemDialog")}
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          Select Item
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <div>
            <label>Select Variant Batch</label>
          </div>
          <Dropdown
            filter
            options={selectItemDialogData.list}
            value={selectedBatchItem}
            onChange={(e) => setSelectedBatchItem(e.value)}
            placeholder="Select"
            className="custom-input p-w-100"
          />
        </DialogContent>
        <DialogActions className="dialog-footer">
          <Button
            className="btn cancel"
            onClick={() => handleClose("ItemDialog")}
          >
            Cancel
          </Button>
          <Button className="btn cancel" onClick={() => addBatchItem()}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={quantityPopupDetails.open}
        onClose={() => handleClose("QuantityPopup")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Quantity</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("QuantityPopup")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <div>
            <div>Enter Quantity of the Item</div>
            <InputText
              onInput={(e) => {
                if (CommonConfig.isEmpty(e?.target?.value)) {
                  setQuantityPopupDetails((prevState) => ({
                    ...prevState,
                    QuantityErr: true,
                    QuantityErrText: "Quantity is required",
                  }));
                } else {
                  if (/^\d*\.?\d*$/i.test(e?.target?.value)) {
                    setQuantityPopupDetails((prevState) => ({
                      ...prevState,
                      Quantity: e?.target?.value,
                      QuantityErr: false,
                      QuantityErrText: "",
                    }));
                  }
                }
              }}
              placeholder="Quantity"
              size="30"
              value={quantityPopupDetails.Quantity}
              autoFocus
              className="p-ml-1"
            />
            <span className="error-msg" style={{ color: "red" }}>
              {quantityPopupDetails.QuantityErr
                ? quantityPopupDetails.QuantityErrText
                : null}{" "}
            </span>
          </div>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("QuantityPopup")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleQuantitySubmit()}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addServiceChargeDialog}
        onClose={() => handleClose("ServiceCharge")}
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          Add Service Charge
        </DialogTitle>
        <DialogContent>
          <GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <div>
                  <div className="custom-inputs e-order-mng p-mt-3">
                    <label className="input-text">Staff Name</label>
                    <Dropdown
                      filter
                      options={serviceChargesList}
                      value={serviceCharge.service}
                      onChange={(e) =>
                        handleServiceChargeChange(e.value, "service")
                      }
                      placeholder="Select Service Charge"
                      className="custom-input p-w-100"
                    />

                    <span className="error-msg" style={{ color: "red" }}>
                      {serviceCharge.serviceErr
                        ? serviceCharge.serviceErrText
                        : null}
                    </span>
                  </div>
                </div>
              </GridItem>

              <GridItem xs={12}>
                <div className="p-w-100">
                  <div className="custom-inputs e-order-mng p-mt-3">
                    <label className="input-text">Amount</label>
                    <InputText
                      value={serviceCharge.amount}
                      placeholder="Enter amount"
                      maxLength={20}
                      onChange={(e) =>
                        handleServiceChargeChange(
                          e.target.value,
                          "amount",
                          /^\d*$/i,
                        )
                      }
                      className="p-w-100"
                    />
                    <span className="error-msg" style={{ color: "red" }}>
                      {serviceCharge.amountErr
                        ? serviceCharge.amountErrText
                        : null}
                    </span>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose("ServiceCharge")}>Cancel</Button>
          <Button onClick={handleServiceChargeSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={barcodeVariantsDialog}
        onClose={() => {
          setBarcodeVariantsDialog(false);
          setBarcodeVariants([]);
          setSelectedBarcodeVariants([]);
          setBarcodeParentItem(null);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Select Variants</DialogTitle>
        <DialogContent>
          <DataTable
            className="main-table table-td e-c-table"
            value={barcodeVariants}
            selection={selectedBarcodeVariants}
            onSelectionChange={(e) => setSelectedBarcodeVariants(e.value)}
            dataKey="_id"
          >
            <Column selectionMode="multiple" headerStyle={{ width: "3em" }} />
            <Column field="DisplayName" header="Variant" />
            <Column
              header="Quantity"
              body={(rowData, props) => {
                return (
                  <InputNumber
                    value={rowData.qty || 1}
                    onValueChange={(e) => {
                      let newVariants = [...barcodeVariants];
                      newVariants[props.rowIndex].qty = e.value;
                      setBarcodeVariants(newVariants);
                    }}
                    min={1}
                  />
                );
              }}
            />
          </DataTable>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setBarcodeVariantsDialog(false);
              setBarcodeVariants([]);
              setSelectedBarcodeVariants([]);
              setBarcodeParentItem(null);
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleAddFromBarcodeDialog}>Add to List</Button>
        </DialogActions>
      </Dialog>

      {/* <ReactToPrint
        trigger={() => (
          <div className="p-d-none">
            <button ref={printButtonRef}>Print</button>
          </div>
        )}
        content={() => componentRef?.current}
        documentTitle="POS"
        onAfterPrint={() => {}} 
      />

      <div className="p-d-none">
        <div className="im-p-dp details-variant-print" ref={componentRef}>
          <div
            dangerouslySetInnerHTML={{
              __html: templateHtml,
            }}
          />
        </div> 
      </div> */}

      <Dialog
        open={previewDialog}
        onClose={() => setPreviewDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Preview Bill</DialogTitle>
        <DialogContent>
          <div className="im-p-dp details-variant-print">
            <div
              dangerouslySetInnerHTML={{
                __html: templateHtml,
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreviewDialog(false)}>Close</Button>
          <Button onClick={handlePrintBill} color="primary" autoFocus>
            Print
          </Button>
        </DialogActions>
      </Dialog>

      <div className="p-d-none">
        {/* Hidden div for any other purpose if needed, but ReactToPrint logic is commented out */}
      </div>
    </div>
  );
};

export default AddPOS;
